@if (isShowFooter()) {
  <div class="mbs-footer">
    <div class="row g-0 mbs-footer-inner">
      <div class="col-12 mbs-footer_logo justify-content-center">
        <a
          class="mbs-footer_logo-link"
          href="https://www.msp360.com"
          target="_blank">
          <img
            alt="MSP360"
            class="mbs-footer_logo-img mbs-footer_logo-msp360"
            src="/images/Logo_main_tag.svg" />
        </a>
      </div>
    </div>
  </div>
}
